<template>
    <tiny-slider
        v-show="groupedSlides.length"
        :items="1"
        :speed="2000"
        :loop="true"
        :gutter="20"
        :autoplay="true"
        :autoplayTimeout="8000"
        ref="slider"
    >
        <div
            v-for="(slide, i) in groupedSlides"
            :key="i"
            class="e-partners__slide"
        >
            <div class="e-partners__slide-inner">
                <div class="e-partners__slide-image" v-for="logo in slide">
                    <img
                        :key="logo.logoURL"
                        :src="logo.logoURL"
                        :alt="logo.name"
                        width="190"
                        height="75"                        
                    />
                </div>
            </div>
        </div>
    </tiny-slider>
</template>

<script>

import TinySlider from 'vue-tiny-slider';
import { animateOnScroll } from "./scrollAnimations";

export default {
    name: "PartnersCarousel",

    components: {
        'tiny-slider': TinySlider,
    },

    props: {
        logos: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            screenWidth: window.innerWidth,
            sliderInstance: null,
        };
    },

    created() {
        // Track screen width changes
        window.addEventListener("resize", this.updateWidth);
    },

    mounted() {
        // Animate logos once slider is ready
        this.$nextTick(() => {
            animateOnScroll(this.$el.querySelectorAll(".e-partners__slide-image"));
        });
        
        this.initSlider();
    },

    beforeUnmount() {
        window.removeEventListener("resize", this.updateWidth);
            if (this.sliderInstance && this.sliderInstance.destroy) {
            this.sliderInstance.destroy();
        }
    },

    computed: {
        // Amount per slide based on breakpoint
        perSlide() {
            if (this.screenWidth >= 1280) return 10; // desktop
            if (this.screenWidth >= 768) return 9; // tablet
            return 10; // mobile
        },

        // Create groups based on current perSlide
        groupedSlides() {
            const groups = [];
            let chunk = [];

            this.logos.forEach((logo) => {
                chunk.push(logo);
                if (chunk.length === this.perSlide) {
                    groups.push(chunk);
                    chunk = [];
                }
            });

            if (chunk.length) groups.push(chunk);

            return groups;
        },
    },

    watch: {
        // If the breakpoint changes, rebuild slider
        perSlide() {
            this.rebuildSlider();
        },

        logos() {
            this.rebuildSlider();
        },
    },

    methods: {
        updateWidth() {
            this.screenWidth = window.innerWidth;
        },

        initSlider() {
            if (this.$refs.slider?.tns) {
                this.sliderInstance = this.$refs.slider.tns;
            }
        },

        rebuildSlider() {
            if (this.sliderInstance?.destroy) {
                this.sliderInstance.destroy();
            }

            // Allow DOM to update before reinitializing
            this.$nextTick(() => {
                this.initSlider();
            });
        },
    },
};

</script>